import { Component, Inject, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { ApiCall } from "@shared/async-services/http/api-call.service";
import { BroadCastServiceService } from "@shared/services/broad-cast-service.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-edit-orgnization",
  templateUrl: "./edit-orgnization.component.html",
  styleUrls: ["./edit-orgnization.component.scss"],
})
export class EditOrgnizationComponent implements OnInit {
	public form: FormGroup;
	public submitted = false;
  loading: boolean = false;
  showSpinner : boolean  = false;
  private countries: any[];
  private states: any[];
  private cities: any[];
  private selectedCountry: any;
  private selectedState: any;
  alphabetPattern = /[a-zA-Z]/g;
  successMsg: any;
  FailMsg : any;
	constructor(
		private auth: ApiCall,
		private fb: FormBuilder,
		private toastr:ToastrService,
		private broadCast:BroadCastServiceService,
		public translate: TranslateService,
		private dialogRef: MatDialogRef<EditOrgnizationComponent>,
		@Inject(MAT_DIALOG_DATA) public editData: any,
	) {}

  ngOnInit(): void {
    this.getAllCountries();
    this.form = this.fb.group({
       organizationName: ['', [Validators.required]],
      //  organizationEmail: ['', [Validators.required, Validators.email,Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]],
       contactNumber: ['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      fixedLimit: ['', [Validators.required]],
      emailNotification:  [true],
      organizationAddress: this.fb.array([]),
		});
    const address = this.form.controls.organizationAddress as FormArray;
    address.push(this.fb.group({
			addressType: ['',[Validators.required]],
			addressDetails: [''],
			country: [''],
			state: [''],
			city: [''],
			zipCode: [''],
		}));

    this.form.patchValue({
      organizationName: this.editData.organizationName,
			// organizationEmail: this.editData.organizationEmail,
      contactNumber: this.editData.contactNumber,
			emailNotification: this.editData.emailNotification,
			fixedLimit: this.editData.fixedLimit,
      organizationAddress : this.editData.organizationAddress,
    });

    // this.form.get('organizationEmail').valueChanges.subscribe((event) => {
    //   this.form.get('organizationEmail').setValue(event.toLowerCase(), { emitEvent: false });
    //   })
  }

  getAllCountries() {
    try {
      this.auth.getAllCountries().subscribe(
        (response: any) => {
          if (response.status === "SUCCESS") {
            this.countries = response.data;

            // Setting the initial state
            let organizationAddress = this.editData.organizationAddress[0];
            this.onCountryChange(organizationAddress?.country);
          }
        },
        (error) => {
          console.error("API failed while getting all countries, ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting all countries, ", error);
    }
  }

  getAllStates(countryId: any) {
    try {
      this.auth.getAllStatesByCountry(countryId).subscribe(
        (response: any) => {
          if (response.status === "SUCCESS") {
            this.states = response.data;

            // Setting the initial city
            let organizationAddress = this.editData.organizationAddress[0];
            this.onStateChange(organizationAddress.state);
          }
        },
        (error) => {
          console.error("API failed while getting all states, ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting all states, ", error);
    }
  }

  getAllCities(countryId: any, stateId: any) {
    try {
      this.auth.getCitiesByCountryAndState(countryId, stateId).subscribe(
        (response: any) => {
          if (response.status === "SUCCESS") {
            this.cities = response.data;
          }
        },
        (error) => {
          console.error("API failed while getting all cities, ", error);
        }
      );
    } catch (error) {
      console.error("Error while getting all cities, ", error);
    }
  }

  onCountryChange(value) {
    try {
      if (this.countries) {
        this.selectedCountry = this.countries.filter(country => country.name.toLowerCase() === value.toLowerCase())[0];
        if (this.selectedCountry) {
          this.getAllStates(this.selectedCountry.id);
        } else {
          this.states = [];
          this.cities = [];
        }
      }
    } catch (error) {
      console.error("Error occurred on country change, ", error);
    }
  }
  onPaste(event: ClipboardEvent) {
		const clipboardData = event.clipboardData || (window as any).clipboardData;
		const pastedData = clipboardData.getData('text');
		if (this.alphabetPattern.test(pastedData)) {
		  event.preventDefault();
		}
	  }
	  
  onStateChange(value) {
    try {
      if (this.states) {
        this.selectedState = this.states.filter(state => state.name.toLowerCase() === value.toLowerCase())[0];
        if (this.selectedState) {
          this.getAllCities(this.selectedState.countryId, this.selectedState.id);
        } else {
          this.cities = [];
        }
      }
    } catch (error) {
      console.error("Error occurred on state change, ", error);
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.form.controls;
  }

  onEdit(): void { 
    this.loading=true;
    this.submitted = true;
      if (this.form.invalid) {
        this.loading=false;
        return;
      }

    this.form.value.id = this.editData.id;
    let requestBody = {
      ...this.form.value,
      userLimit: this.editData.userLimit 
    }
    this.auth
      .updateSuperAdminOrganization(this.form.value)
      .subscribe((res: any) => {
        try {
          if (res.status == "SUCCESS") {
          this.dialogRef.close(false);
          this.successMsg = res.message; 
					this.translate.get(['SUPER_ADMIN.ORGANIZATIONS.ADD_ORGANIZATION.EDIT_SUCCESS'])
              .subscribe(translations => {
              this.successMsg = translations['SUPER_ADMIN.ORGANIZATIONS.ADD_ORGANIZATION.EDIT_SUCCESS'];
            });
            this.toastr.success(this.successMsg, "", {
              timeOut: 3000,
            });
          } else {
            if(res.message == 'Please select user limit equal to or greater than current users') {
              this.translate.get(['DECREASE_EXISTING_ACCOUNTANT_LIMIT']).subscribe(translation=>{
                this.FailMsg = translation['DECREASE_EXISTING_ACCOUNTANT_LIMIT']
                this.toastr.error(this.FailMsg, "")
              })
            } else{
            this.translate.get(['SUPER_ADMIN.ORGANIZATIONS.ADD_ORGANIZATION.EDIT_FAIL'])
            .subscribe(translation=>{
            this.FailMsg = translation['SUPER_ADMIN.ORGANIZATIONS.ADD_ORGANIZATION.EDIT_FAIL']
            });
            this.toastr.error(this.FailMsg,"",{
              timeOut: 3000,
            })
          }
          }
          this.broadCast.sendMessage("displayData");
          this.broadCast.sendMessage("organization");
        } catch {
          this.toastr.error("Error occured while updating orgnization.", "", {
            timeOut: 3000,
          });
        }
      },(error) => {

      },() => {
        this.loading = false; 
      });
  }

  close(): void {
    this.dialogRef.close(false);
  }

  keyPress(event: any) {
		const pattern = /[0-9 ]/;
	
		let inputChar = String.fromCharCode(event.charCode);
		if (event.keyCode != 8 && !pattern.test(inputChar)) {
		  event.preventDefault();
		}
	  }

  getControls() {
    return (this.form.get('organizationAddress') as FormArray).controls;
  }

  enforceMaxValue(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = parseInt(input.value, 10);
    if (value > 10216) {
      input.value = '10216';
    }
  }
}
